var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"checkout",attrs:{"id":"portfolio"}},[_c('h5',[_vm._v("Portfolio")]),_c('h3',[_vm._v("Checkout a few of my projects")])])
}]

export { render, staticRenderFns }